import axios from '@/user/axios.js'
import { fileDownload } from '@/utils'

const moduleAdBid = {
  namespaced: true,
  state: {
    bids: [],
    portfolios: {}
  },
  mutations: {
    SET_BID_LIST (state, payload) {
      state.bids = payload
    },
    SET_PORTFOLIO_LIST (state, payload) {
      state.portfolios = payload
    }
  },
  actions: {
    listPortfolios (context) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/ad-bid/portfolios/${sellerId}`)
          if (res.data.success) {
            const portfolios = {}
            for (const portfolio of res.data.data) {
              portfolios[portfolio.id] = {
                name: portfolio.name,
                amount: portfolio.amount,
                policy: portfolio.policy,
                startDate: portfolio.startDate,
                endDate: portfolio.endDate,
                existDeliveryDownRule: portfolio.existDeliveryDownRule
              }
            }
            context.commit('SET_PORTFOLIO_LIST', portfolios)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listBids (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/ad-bid/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_BID_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    getBid (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { id } = payload
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/ad-bid/${sellerId}/${id}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    addBid (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.post(`/api/ad-bid/${sellerId}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    updateBid (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { id, ...data } = payload
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.put(`/api/ad-bid/${sellerId}/${id}`, data)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    statusBid (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { id, ...data } = payload
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.put(`/api/ad-bid/status/${sellerId}/${id}`, data)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    deleteBid (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { id } = payload
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.delete(`/api/ad-bid/${sellerId}/${id}`)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    destroyBids (context) {
      context.commit('SET_BID_LIST', [])
    },
    downloadCSV (context) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/ad-bid/download/${sellerId}`, { responseType: 'blob' })
          const fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1])
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleAdBid
